<template>
    <div>
        <article v-if="error_message !== ''">
          <h3>異常原因:</h3>
          <section>{{error_message}}</section>
        </article>
    </div>
</template>

<script>
import liff from "@line/liff";

export default {
  name: 'LineLogin',
  components: {
  },
  data: function() {
    return {
      error_message: '',
    }
  },
  created: function() {
    console.log('liff', liff)
    let that = this
    liff.init({
        'liffId': process.env.VUE_APP_LIFF_QUICK_LOGIN
    }).then(function(){
      that.initApp()
    }).catch(function(error){
      that.error_message = `init-${error.toString()}`
      console.log(error)
    })
  },
  methods: {
    initApp: function(){
      let that = this
      let aParams = document.location.search.substr(1);

      if (!liff.isLoggedIn() && !liff.isInClient()) {
        let redirect_url = 'https://' + window.location.hostname + window.location.pathname
        liff.login({ redirectUri: redirect_url });
      }
      else {
        //已經登入 或 在Line裡
        var accessToken = liff.getAccessToken();
        var userId = '';
        liff.getProfile().then(function(profile) {
            userId = profile.userId;
            location.href = 'https://' + window.location.hostname + '/?accessToken=' + accessToken + '&userId=' + userId + ((aParams == null || aParams == '') ? '' : '&' + aParams);
        }).catch(function(error) {
          that.error_message = `app-${error.toString()}`
          liff.logout();
        });
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
